"use strict";

{

    const uid = () => {
        return (Date.now().toString(36) + Math.random().toString(36).substring(2));
    };

    class QuickAdd {
        /** @type {HTMLDivElement} */
        constructor({ elem }) {

            this.uniq = uid();

            this.dom = {
                main: elem,
                trigger: elem.querySelector('.quick-add__open'),
                radios: elem.querySelectorAll('.SizeSwatch__Radio'),
                labels: elem.querySelectorAll('.SizeSwatch__Label'),
                price: elem.querySelector('.quick-add__price [data-price]'),
                compareAtPrice: elem.querySelector('.quick-add__price [data-compare-at-price]'),
                quantitySelector: {
                    increase: elem.querySelector('.quick-add__quantitySelector [data-action="increase-quantity"]'),
                    decrease: elem.querySelector('.quick-add__quantitySelector [data-action="decrease-quantity"]'),
                    input: elem.querySelector('.quick-add__quantitySelector input')
                },
                submit: elem.querySelector('.quick-add__add-to-cart')
            }

            elem.classList.remove('js-quick-add');

            this.init();
        }

        init() {
            this.uniqify();
            this.addEventListeners();
            // this.changePriceOnClick();
            this.changeQuantity();
            this.submitClick();
        }

        uniqify() {
            this.dom.radios.forEach((radio, index) => {
                const variantId = radio.getAttribute('data-variant-id');
                radio.setAttribute('name', this.uniq);
                radio.setAttribute('id', variantId + '-' + this.uniq);

                this.dom.labels[index].setAttribute('for', variantId + '-' + this.uniq);
            });
        }

        addEventListeners() {
            this.dom.trigger.addEventListener('click', () => {
                this.dom.main.classList.add('open')
            })

            this.dom.main.addEventListener('mouseleave', () => {
                const closeElem = () => {
                    this.dom.main.classList.remove('open')
                }
                const closingTimer = setTimeout(closeElem, 1000);
                this.dom.main.addEventListener('mouseenter', () => {
                    clearTimeout(closingTimer); 
                });
            })
        }

        changePriceOnClick() {
            this.dom.radios.forEach(radio => {
                radio.addEventListener('change', () => {

                    const price = Number(radio.dataset.price);
                    const compareAtPrice = Number(radio.dataset.compareAtPrice);
                })
            });
        }

        changeQuantity() {
            const min = 1;
            const max = 99;
            this.dom.quantitySelector.increase.addEventListener('click', () => {
                if (this.dom.quantitySelector.input.value < max) {
                    this.dom.quantitySelector.input.value = Number(this.dom.quantitySelector.input.value) + 1
                }
            })

            this.dom.quantitySelector.decrease.addEventListener('click', () => {
                if (this.dom.quantitySelector.input.value > min) {
                    this.dom.quantitySelector.input.value = Number(this.dom.quantitySelector.input.value) - 1
                }
            })
        }

        submitClick() {

            this.dom.submit.addEventListener('click', () => {
                const selectedVariant = [...this.dom.radios].find(x => x.checked == true);
                if (!selectedVariant) return;

                const variantId = Number(selectedVariant.dataset.variantId)
                const quantity = Number(this.dom.quantitySelector.input.value);

                this.addToCart({ variantId: variantId, quantity: quantity });
            })
        }

        addToCart({ variantId, quantity }) {
            const formData = { items: [{ 'id': variantId, 'quantity': quantity }] };

            fetch('/cart/add.js', {
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                },
                body: JSON.stringify(formData)
            })
                .then(response => {
                    return response.json().then(data => {
                        if (response.ok) {
                            document.dispatchEvent(new CustomEvent('product:added', {
                                bubbles: true,
                                detail: {
                                    variant: variantId,
                                    quantity: quantity
                                }
                            }));

                        } else {
                            this.errorHandler({ errorData: data });
                        }
                    })

                }).catch((error) => {
                    console.error('Error:', error);
                });
        }

        errorHandler({ errorData }) {

            switch (errorData.status) {
                case 422: //Not enough inventory  
                    this.errorAlertMessage({ errorData });
                    break;
            }
        }

        errorAlertMessage({ errorData }) {
            setTimeout(() => {
                alert(errorData.description)
            }, 400);
        }


    }

    const initQuickAdd = () => {
        const quickAddElems = document.querySelectorAll('.js-quick-add');

        quickAddElems.forEach(quickAddElem => {
            void new QuickAdd({ elem: quickAddElem })
        });
    }

    initQuickAdd();

    document.addEventListener('boostFilter:rendered', () => {
        initQuickAdd();
    });

    document.addEventListener('Carousel:Build', () => {
        initQuickAdd();
    });
}